
export function SectionPricing1Inner() {
  return (
    <>
      <div className="container mx-auto">
        {/* TITLE START */}
        <div className="section-head center">
          <div className="sx-head-l-title">
            <h2 className="sx-title pb-4">Our Best Pricing</h2>
          </div>
        </div>
        {/* TITLE END */}
        <div className="section-content">
          <div className="sx-p-table-section">
            {/*Block One*/}
            <div
              className="sx-p-table-bx-1 wow fadeInDown t-r-first"
              data-wow-duration="1000ms"
              style={{ width: "43%" }}
            >
              <div className="sx-p-table-bx-1-top">
                <h2 className="sx-title">Plan</h2>
              </div>
              <div className="sx-p-table-bx-1-mid">
                <ul>
                  <li>Professional online presence for your business</li>
                  <li>Works perfectly on mobile, tablet, and desktop</li>
                  <li>Fast loading website</li>
                  <li>Basic contact form for customer enquiries</li>
                  <li>Social media links integration</li>
                  <li>Admin panel to manage website data easily</li>
                  <li>Customer enquiry data saved automatically</li>
                  <li>Better control over business information</li>
                  <li>Business reports and performance insights</li>
                  <li>High security for customer data</li>
                  <li>Email Service</li>
                  <li>Google Reviews & Footprinting</li>
                </ul>
              </div>
              {/* <div className="sx-p-table-bx-1-bottom" /> */}
            </div>
            {/* -------------- */}
            <div
              className="sx-p-table-bx-2 wow fadeInDown t-r-four"
              data-wow-duration="1000ms"
            >
              <div className="sx-p-table-bx-2-top-title">
                <span>Beginner</span>
              </div>
              <div className="sx-p-table-bx-2-top">
                <h3 className="sx-price">Rs. 9999/-</h3>
              </div>
              <div className="sx-p-table-bx-2-mid">
                <ul>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Professional online presence for your business</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Works perfectly on mobile, tablet, and desktop</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Fast loading website</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Basic contact form for customer enquiries</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Social media links integration</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>Admin panel to manage website data easily</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>Customer enquiry data saved automatically</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>Better control over business information</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>Business reports and performance insights</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>High security for customer data</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>Email Service</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>Google Reviews & Footprinting</span>
                  </li>
                </ul>
              </div>
            </div>
            {/*Block five*/}
            <div
              className="sx-p-table-bx-2 wow fadeInDown t-r-five"
              data-wow-duration="1000ms"
            >
              <div className="sx-p-table-bx-2-top-title">
                <span>Professional</span>
              </div>
              <div className="sx-p-table-bx-2-top">
                <h3 className="sx-price">Rs. 15k - 20k</h3>
              </div>
              <div className="sx-p-table-bx-2-mid">
                <ul>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Professional online presence for your business</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Works perfectly on mobile, tablet, and desktop</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Fast loading website</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Basic contact form for customer enquiries</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Social media links integration</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Admin panel to manage website data easily</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Customer enquiry data saved automatically</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Better control over business information</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Business reports and performance insights</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>High security for customer data</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>Email Service</span>
                  </li>
                  <li>
                    <div className="sx-plan-disable">
                      <i className="feather-x" />
                    </div>
                    <span>Google Reviews & Footprinting</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* -------------- */}
            <div
              className="sx-p-table-bx-2 wow fadeInDown t-r-five"
              data-wow-duration="1000ms"
            >
              <div className="sx-p-table-bx-2-top-title">
                <span>Primium</span>
              </div>
              <div className="sx-p-table-bx-2-top">
                <h3 className="sx-price">Rs. 45k+</h3>
              </div>
              <div className="sx-p-table-bx-2-mid">
                <ul>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Professional online presence for your business</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Works perfectly on mobile, tablet, and desktop</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Fast loading website</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Basic contact form for customer enquiries</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Social media links integration</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Admin panel to manage website data easily</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Customer enquiry data saved automatically</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Better control over business information</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Business reports and performance insights</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>High security for customer data</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Email Service</span>
                  </li>
                  <li>
                    <div className="sx-plan-enable">
                      <i className="feather-check" />
                    </div>
                    <span>Google Reviews & Footprinting</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function SectionPricing1() {
  return (
    <div
      className="
        section-full
        sx-p-table-outer
        sx-bg-white
        wow fadeInDown
      "
      style={{
        paddingTop: "20px",
        paddingBottom: "110px",
        overflowX: "hidden",
      }}
      data-wow-duration="1000ms"
    >
      <SectionPricing1Inner />
    </div>
  );
}

export default SectionPricing1;
